import React, { useEffect, useState } from "react";
import ProfileHistoriqueAchatsTab from "./profile-historique-achats-tab.js";
import ProfileDepotsTab from "./profile-depots-tab.js";
import ProfileFermerEnregistrementTab from "./profile-fermer-enregistrement-tab.js";
import PaiementComptesPage from "./paiement-comptes/paiement-comptes-page.js";
import ProfileDependantsPopup from "./profile-dependants-popup.js";
import ProfileVehiculesPopup from "./profile-vehicules-popup.js";

const TABS = {
  profile: "profile",
  purchaseHistory: "historique-achats",
  depots: "depots",
  options: "options",
  paiementComptes: "paiement-comptes",
};
const TAB_ITEMS = [
  { value: TABS.profile, id: "profile", panelId: "profile", textKey: "tabProfile" },
  { value: TABS.purchaseHistory, id: "purchase-history", panelId: "purchase-history", textKey: "tabPurchaseHistory" },
  { value: TABS.depots, id: "depots", panelId: "depots", textKey: "tabDepots" },
  { value: TABS.options, id: "options", panelId: "options", textKey: "tabEnregistrements" },
  { value: TABS.paiementComptes, id: "paiement-comptes", panelId: "paiement-comptes", textKey: "tabPaiementComptes" },
];

export default function ProfileConnectedPanel({
  connectedProfileTab,
  texts,
  history,
  location,
  renderChampsProfile,
  hadDependants,
  configuration,
  dependants,
  entrepriseContact,
  onEditDependant,
  onDeleteDependant,
  onAddDependant,
  vehicules,
  onEditVehicule,
  onDeleteVehicule,
  onAddVehicule,
  renderEmbarcations,
  renderRemorques,
  stationDeLavage,
  canSave,
  onValidateAndSave,
  match,
  idZec,
  authToken,
  setAlert,
}) {
  const [activeTab, setActiveTab] = useState(connectedProfileTab);

  useEffect(() => {
    setActiveTab(connectedProfileTab);
  }, [connectedProfileTab]);

  const validTabs = new Set(Object.values(TABS));

  function navigateProfileConnectedTab(tab) {
    if (!validTabs.has(tab))
      return;

    const params = new URLSearchParams(location.search || "");
    if (tab === TABS.profile)
      params.delete("tab");
    else
      params.set("tab", tab);

    const search = params.toString() ? `?${params.toString()}` : "";
    const current = location.search || "";
    if (search !== current)
      history.replace({ pathname: location.pathname, search });
    else if (tab !== activeTab)
      setActiveTab(tab);
  }

  return (
    <div id="profile-page" className="profile-div">
      <div className="profile-tabs" role="tablist">
        {TAB_ITEMS.map((tab) => (
          <button
            key={tab.value}
            type="button"
            role="tab"
            id={`profile-tab-${tab.id}`}
            aria-selected={activeTab === tab.value}
            aria-controls={`profile-tabpanel-${tab.panelId}`}
            className={"profile-tab" + (activeTab === tab.value ? " profile-tab--active" : "")}
            onClick={() => navigateProfileConnectedTab(tab.value)}
          >
            <span className="profile-span">{texts[tab.textKey]}</span>
          </button>
        ))}
      </div>
      {activeTab === TABS.profile && (
        <div
          id="profile-tabpanel-profile"
          role="tabpanel"
          aria-labelledby="profile-tab-profile"
          className="profile-tab-panel"
          style={{ display: "flow-root" }}
        >
          {renderChampsProfile()}
          <div className="profile-div profile-separator" />
          <ProfileDependantsPopup
            hadDependants={hadDependants}
            configuration={configuration}
            dependants={dependants}
            entrepriseContact={entrepriseContact}
            onEditDependant={onEditDependant}
            onDeleteDependant={onDeleteDependant}
            onAddDependant={onAddDependant}
          />
          <div className="profile-div profile-separator" />
          <ProfileVehiculesPopup
            vehicules={vehicules}
            onEditVehicule={onEditVehicule}
            onDeleteVehicule={onDeleteVehicule}
            onAddVehicule={onAddVehicule}
          />
          {stationDeLavage && <div className="profile-div profile-separator" />}
          {stationDeLavage && renderEmbarcations()}
          {stationDeLavage && <div className="profile-div profile-separator" />}
          {stationDeLavage && renderRemorques()}
          {canSave && (
            <div id="profile-save-wrapper" className="profile-div clickable" onClick={() => onValidateAndSave()}>
              <span className="profile-span">SAUVEGARDER</span>
            </div>
          )}
        </div>
      )}
      {activeTab === TABS.purchaseHistory && (
        <div
          id="profile-tabpanel-purchase-history"
          role="tabpanel"
          aria-labelledby="profile-tab-purchase-history"
          className="profile-tab-panel profile-tab-panel--empty"
        >
          <ProfileHistoriqueAchatsTab
            language={match.params.language}
            idZec={idZec}
            authToken={authToken}
            setAlert={setAlert}
          />
        </div>
      )}
      {activeTab === TABS.depots && (
        <div
          id="profile-tabpanel-depots"
          role="tabpanel"
          aria-labelledby="profile-tab-depots"
          className="profile-tab-panel profile-tab-panel--empty"
        >
          <ProfileDepotsTab
            language={match.params.language}
            idZec={idZec}
            authToken={authToken}
            setAlert={setAlert}
          />
        </div>
      )}
      {activeTab === TABS.options && (
        <div
          id="profile-tabpanel-options"
          role="tabpanel"
          aria-labelledby="profile-tab-options"
          className="profile-tab-panel profile-tab-panel--empty"
        >
          <ProfileFermerEnregistrementTab language={match.params.language} />
        </div>
      )}
      {activeTab === TABS.paiementComptes && (
        <div
          id="profile-tabpanel-paiement-comptes"
          role="tabpanel"
          aria-labelledby="profile-tab-paiement-comptes"
          className="profile-tab-panel profile-tab-panel--empty"
        >
          <PaiementComptesPage match={match} />
        </div>
      )}
    </div>
  );
}
